"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureStyles = void 0;
const lit_1 = require("lit");
exports.featureStyles = (0, lit_1.css) `
  :host {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-3);
    width: 100%;
    position: relative;
    z-index: var(--material-zindex-elevated);
  }

  :host([centered]) {
    align-items: center;
  }

  .feature-emoji {
    font-size: var(--font-size-24);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZS5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmZWF0dXJlLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBeUI7QUFFWixRQUFBLGFBQWEsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0IvQixDQUFBIn0=